import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-centros',
  templateUrl: './centros.component.html',
  styleUrls: ['./centros.component.scss'],
  providers: [CommonService]
})
export class CentrosComponent implements OnInit {
  public selectedCiudad:any;
  public centro:any;
  public centros:any[];
  public ciudades:any[];
  public barrios:any[];

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.selectedCiudad = 0;

    this.centro = {
      nombre: '',
      calle: '',
      numero: '',
      barrios_id: 0,
      telefono: '',
      secretaria: '',
      latitud: '',
      longitud: ''
    };

    Promise.all([
      this.commonService.getCiudades(),
      this.commonService.getCentros()
    ]).then(result => {
      this.ciudades = result[0];
      this.centros = result[1];
    })
  }
  
  public getBarrios() {
    this.barrios = [];
    this.centro.barrios_id = 0;

    this.commonService.getBarriosXCiudad(this.selectedCiudad)
      .then(result => { this.barrios = result; });
  }

  public saveCentro() {
    this.commonService
      .saveCentro(this.centro)
      .then(() => {
        this.centro = {
          nombre: '',
          calle: '',
          numero: '',
          barrios_id: 0,
          telefono: '',
          secretaria: '',
          latitud: '',
          longitud: ''
        };

        this.commonService.getCentros()
          .then(result => this.centros = result);
    });
  
  }

}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/centros/centros.component.ts